const BRANDS = new Set(['becaisse', 'bekiosk', 'beresto', 'beclick', 'bemenu']);
const RETURNS = new Set(['admin', 'caisse', 'pad', 'cuisine']);
export function befidAddonUrl(brand, returnTo = 'admin', page = 'admin') {
  if (!BRANDS.has(brand) || !RETURNS.has(returnTo) || !['admin', 'tablet'].includes(page)) return null;
  return `/befid-app/addon/${brand}/${page}?return=${returnTo}`;
}
export function befidEntryAccess(payload, page = 'admin') {
  if (payload?.schemaVersion !== 1 || typeof payload.allowed !== 'boolean' || !['addon', 'standalone', 'legacy', 'none'].includes(payload.mode) || typeof payload.capabilities?.[page] !== 'boolean') throw new Error('Réponse BEFID invalide');
  return payload.allowed && payload.capabilities[page];
}
